import { cx } from "@emotion/css";
import { Button } from "@mui/material";
import Spinner from "library/Atoms/Spinner";
import { PropTypes } from "prop-types";

const SecondaryButton = ({ contentClassName, label, color, loading, endIcon, ...restProps }) => (
  <Button variant="outlined" color={color} endIcon={!loading && endIcon} {...restProps}>
    <div className={cx(contentClassName, "d-flex align-items-center")}>
      {loading ? <Spinner color={color} /> : <span className="text-capitalized text-truncate">{label}</span>}
    </div>
  </Button>
);

SecondaryButton.defaultProps = {
  contentClassName: "",
  label: "",
  endIcon: null,
  color: "primary",
  loading: false,
};

SecondaryButton.propTypes = {
  contentClassName: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  endIcon: PropTypes.node,
  color: PropTypes.oneOf(["primary", "warning"]),
  loading: PropTypes.bool,
};

export default SecondaryButton;
